export const servicesRoute = "/:region/venue/:location/menu/services";

export const listRoute = ":tab(list|week|day)?";
